// File: components/academySectionsComponents/AcademyHeroSection.jsx

import React from "react";
import "./AcademyHeroSection.css";
import { useNavigate } from "react-router-dom";

// 👇 IMPORT YOUR DOWNLOADED VIDEO HERE
import academyVideo from "../../Assets/videos/traillerteaser.mp4";

export default function AcademyHeroSection() {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact-us");
  };

  return (
    <section className="academy-hero-section">

      {/* Background Video */}
      <video
        className="academy-hero-bg-video"
        autoPlay
        loop
        muted
        playsInline
        controls={false}
        disablePictureInPicture
        disableRemotePlayback
      >
        <source src={academyVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Dark Overlay for Text Readability */}
      <div className="academy-hero-overlay"></div>

      {/* Accent Glows */}
      <div className="academy-hero-glow"></div>

      {/* Centered Content */}
      <div className="academy-hero-container">
        <div className="academy-hero-content">
          
          <h1>Ample Academy</h1>

          <h3>Teach leadership through systems.</h3>

          <p>
            Develop leaders through structured learning and immersive education
            with Ample Academy. We combine strategy, discipline, and innovation
            to build future-ready leaders.
          </p>

          <button
            className="academy-hero-btn"
            onClick={handleNavigate}
          >
            Contact Us
          </button>

        </div>
      </div>

    </section>
  );
}